import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { EditConnectionPage } from '../../../../../../../components/EditConnectionPage.tsx'

const Page = (): ReactElement => {
  const { organizationId, sourceId } = Route.useParams()

  return <EditConnectionPage organizationId={organizationId} sourceId={sourceId} />
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/sources/$sourceId/connection')({
  component: Page,
})
